import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerSwitchService {
  private customerSwitched$: Subject<boolean> = new Subject<boolean>();

  next(switched: boolean): void {
    this.customerSwitched$.next(switched);
  }

  isCustomerSwitched(): Observable<boolean> {
    return this.customerSwitched$.asObservable();
  }
}
